<template lang="pug">
  .component-create-entity-button
    ModalReveal(:ref="componentId", @input="closeInput",  :key="key")
      a.fa-stack.fa-lg(slot="trigger")
        i.fa.fa-circle.fa-stack-2x
        i.fa.fa-plus.fa-stack-1x.fa-inverse
      .row
        .columns.small-12.large-6
          h2 Plan Details
          hr
          .row
            .column
              label Plan Name
              input(type='text', v-model="plan.name")
              label Title
              input(type='text', v-model="plan.title")
          .row
            .column
              label Duration (days)
              input(type='text', v-model="plan.duration")
              small The contractual commitment of the plan (days).
            .column
              label Subscription End
                DatePicker(v-model="plan.subscription_end", :initialDate="plan.subscription_end", :pickTime="true", format="yyyy-mm-dd", :clearCb="()=>{plan.subscription_end = null}")
            .column
              label Max Drivers
              input(type='text',  v-model="plan.max_drivers")
              label Status
              select(v-model="plan.status")
                option AVAILABLE
                option UNAVAILABLE
                option DISABLED
          .row
            .columns
              label Color
                input(type="text", v-model="plan.color")
            .columns
              label Notice
                input(type="text", v-model="plan.notice")
          .row.column
            label Toc
            SelectizeToc(@optionSelected="setTocId", @optionRemoved="plan.toc_id = null", :selectedValue="plan.toc_id")
        .columns.small-12.large-6
          h2 Plan Costs
          hr
          .row
            .column
              label Subscriptions can be renewed? &nbsp;
                input(type="checkbox", v-model="plan.renewable")
              label Featured &nbsp;
                input(type="checkbox", v-model="plan.featured")
          .row
            .columns
              VatAmountToggler(label="Cost", v-model="plan.cost", :tax="configuration.commercial.commercial_vat_rate.value")
            .columns(v-if="plan.renewable")
              label Billing Cycle (days)
                input(type='text', v-model="plan.billing_cycle")
              small The frequency (days) with which the plan cost is charged
          .row
            .columns.large-6
              label Active From
                DatePicker(v-model="plan.valid_from", :initialDate="plan.valid_from", :pickTime="true", format="yyyy-mm-dd hh:ii:ss", :clearCb="()=>{plan.valid_from = null}")
            .columns.large-6
              label Active To
                DatePicker(v-model="plan.valid_to", :initialDate="plan.valid_to", :pickTime="true", format="yyyy-mm-dd hh:ii:ss", :clearCb="()=>{plan.valid_to = null}")
          .row.columns

          .row.columns
            label Picture
            KeplerFileUpload(@sel="handleFileSelector", selected-prefix="plans", selected-visibility="public", :previewUrl="plan.picture")
      .row
        .column
          label Description
          Editor(v-model="plan.description", :value="plan.description")
      ActionButton(slot="footer", :action="save") Save
      button.button.alert.float-right(slot="footer", @click="$refs[componentId].close()") Cancel


</template>

<script>
import KeplerBackofficeSdk from 'src/lib/kepler/backoffice'
import SelectizeToc from "../../components/structure/ui/lists/selectize/SelectizeToc";
import ActionButton from "../../components/structure/ui/ActionButton";
import KeplerFileUpload from "../../components/structure/KeplerFileUpload";
import DatePicker from "../../components/structure/DatePicker";
import ModalReveal from "../../components/structure/foundation/ModalReveal";
import VatAmountToggler from "../../components/backoffice/VatAmountToggler";
import Editor from "../../components/structure/ui/Editor";
import MaggieHelper from "../../maggieHelper";
import {mapState} from "vuex";
import moment from "moment";

export default {
  name: 'CouponReveal',
  components: {Editor, VatAmountToggler, ModalReveal, DatePicker, KeplerFileUpload, ActionButton, SelectizeToc},
  data() {
    return {
      plan: {
        name: null,
        title: null,
        toc_id: null,
        picture: null,
        notice: null,
        color: null,
        description: "",
        cost: 0,
        status: "AVAILABLE",
        featured: false,
        renewable: true,
        billing_cycle: 90,
        max_drivers: 1,
        duration: 30,
        valid_from: null,
        valid_to: null,
        subscription_end: null,
      },
      key:0
    }
  },
  created() {

  },
  watch: {
    'plan.subscription_end': function (newVal, oldVal) {
      if(newVal != null) {
        var end = moment(newVal, 'YYYY-MM-DD')
        this.plan.duration = end.diff(moment().format('YYYY-MM-DD'), 'days')
      }
    }
  },
  methods: {
    setTocId(obj) {
      this.plan.toc_id = obj.id
    },
    closeInput(event) {
      if(!event) {
        this.key++
      }
    },
    save() {
      return KeplerBackofficeSdk.plans.make(this.plan, (data) => {
        MaggieHelper.notification('Plan saved', 'Plan saved successfully', 'success')
        this.key++
        this.$refs[this.componentId].close()
        location.reload()
      })
    },
    handleFileSelector(path) {
      this.plan.picture = path
    },
  },
  computed: {
    componentId() {
      return `planReveal-${this._uid}`
    },
    ...mapState({
      configuration: state => state.configuration,
    }),
  },
  props: {
    couponProp: {
      type: Object,
      default: null
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// PlanReveal.vue?7abe2f52